import { defineModule } from '../types.js';
export default defineModule({
    id: 'personnel',
    nom: 'Personnel',
    description: 'Masse salariale, rémunérations, salariés et trajectoires salariales.',
    famille: 'personnel',
    dependances: [],
    activableParDefaut: true,
    desactivable: true,
    routesApi: ['/api/admin/salaries', '/api/admin/hypotheses'],
    droits: {
        'personnel.consulter': { description: 'Consulter la masse salariale et les rémunérations', niveau: 'lecture' },
        'personnel.administrer': { description: 'Modifier les salariés et les hypothèses salariales', niveau: 'administration' },
    },
    navigation: [
        { cle: 'masse-salariale', libelle: 'Masse salariale', picto: '☰', groupe: 'Pilotage', ordre: 75, droit: 'personnel.consulter' },
        { cle: 'remunerations', libelle: 'Rémunérations', picto: '☰', groupe: 'Administration', ordre: 95, droit: 'personnel.consulter' },
    ],
});
//# sourceMappingURL=personnel.js.map